
import service from '@/store/services/settings/guidance-categories-service';

const state = {
    list: {},
    guidanceCategory: {},
    meta: {},
    guidance: {},

};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, guidanceCategory) => {
        state.guidanceCategory = guidanceCategory;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(guidanceCategory => {
                commit('SET_RESOURCE', guidanceCategory);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(guidanceCategory => {
                commit('SET_RESOURCE', guidanceCategory);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((guidanceCategory) => {
                commit('SET_RESOURCE', guidanceCategory);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((guidanceCategory) => {
                commit('SET_RESOURCE', guidanceCategory);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
    guidances ({ commit, dispatch }, { category,params = {} }) {
        return service.guidances(category,params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    guidanceCategory: state => state.guidanceCategory,
    guidance: state=> state.guidance,
    dropdown: (state) => {
        return state.list.map(guidanceCategory => ({
            id: guidanceCategory.id,
            name:guidanceCategory.name,
            code:guidanceCategory.code,
        }));
    }
};

const guidanceCategories = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default guidanceCategories;
